import { useState } from "react"

const useFieldChange = (callback = () => null, validation = () => null) => {

	const [stateErrors, setStateErrors] = useState({})


	const handleChange = (e, type = null) => {
		const {name, value, checked} = e.target;
		if(typeof callback == 'function' && callback != null){
			const insertValue = (type != 'checkbox') ? value : checked;
			callback((prevState) => ({
				...prevState,
				[name]: insertValue
			}))

			if(typeof validation == 'function' && validation != null){
				const hasError = validation(name, value);

				if(typeof hasError == 'object'){
					setStateErrors((prevState) => ({
						...prevState,
						[name]: hasError
					}))
				}
				else {
					setStateErrors((prevState) => ({
						...prevState,
						[name]: hasError
					}))
				}
			}
		}
	}

	const handleErrors = (object) => {
		let errors = {};
		let hasErrors = false;
		Object.keys(object).map((key, value) => {
			if(object[key] == null || object[key] == ""){
				errors[key] = true;
				hasErrors = true;
			}
			else {
				errors[key] = false;
			}
			return errors;
		})

		setStateErrors(errors);

		return hasErrors;
	}

	const anyErrors = () => {
		let errors = false;
		Object.keys(stateErrors).map((key, value) => {
			if(stateErrors?.[key]?.error){
				errors = true;
			}
		})
		return errors;
	}


    return {
        handleChange, 
		handleErrors,
		setErrors: setStateErrors,
		errors: stateErrors,
		anyErrors
    }
}

export default useFieldChange;